<script setup lang="ts">
/* eslint-disable vue/no-v-html */
import type { PostData } from '@/types';
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';
import ShareButton from '@/components/share-button/ShareButton.vue';

defineProps<Pick<PostData, 'authors'>>();
</script>

<template>
  <ContentContainer class="analysis-footer">
    <ContentColumn>
      <div class="analysis-footer">
        <div class="authors">
          <div
            v-for="(author, key) in authors"
            :key="key"
            class="author-detail"
          >
            <NuxtImg
              v-if="author.image"
              :src="author.image"
              :alt="author.name"
              :title="author.name"
              class="author-image"
              width="48"
              height="48"
            />
            <div class="author-description">
              <div class="author-name heading-5">
                {{ author.name }}
              </div>
              <p class="author-title body-small">
                {{ author.title }}, {{ author.organisation }}
              </p>
              <div v-if="author.bio" class="author-bio body-small" v-html="author.bio" />
            </div>
          </div>
        </div>
      </div>
      <ShareButton />
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.analysis-footer {
  margin-bottom: var(--spacing-ml);
}

.authors {
  border-top: 0.5px solid var(--colour-warm-grey);
}

.author-detail {
  padding: var(--spacing-ml) 0;
  display: flex;
  gap: var(--spacing-ms);
  border-bottom: 0.5px solid var(--colour-warm-grey);
}

.author-image {
  width: 4.8rem;
  height: 4.8rem;
  object-fit: cover;
  border-radius: 2.4rem;
  flex-shrink: 0;
}

.author-description {
  :last-child {
    margin-bottom: 0;
  }
}

.author-name {
  margin-top: 6px;
  margin-bottom: 0.24rem;
}
.author-title,
.author-bio {
  color: var(--colour-mid-grey);
}
</style>
